/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Context_Menu_Delete_Success_ToastInputs */

const en_context_menu_delete_success_toast = /** @type {(inputs: Context_Menu_Delete_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Events deleted from group successfully`)
};

const fr_context_menu_delete_success_toast = /** @type {(inputs: Context_Menu_Delete_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evenements supprimes du groupe avec succes`)
};

const de_context_menu_delete_success_toast = /** @type {(inputs: Context_Menu_Delete_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ereignisse erfolgreich aus der Gruppe gelöscht`)
};

const it_context_menu_delete_success_toast = /** @type {(inputs: Context_Menu_Delete_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eventi eliminati dal gruppo con successo`)
};

const ru_context_menu_delete_success_toast = /** @type {(inputs: Context_Menu_Delete_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`События, удаленные из группы, успешно удалены.`)
};

const es_context_menu_delete_success_toast = /** @type {(inputs: Context_Menu_Delete_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eventos eliminados del grupo exitosamente`)
};

const zh_cn2_context_menu_delete_success_toast = /** @type {(inputs: Context_Menu_Delete_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已成功从组中删除事件`)
};

const ja_context_menu_delete_success_toast = /** @type {(inputs: Context_Menu_Delete_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`グループからイベントが正常に削除されました`)
};

const hi_context_menu_delete_success_toast = /** @type {(inputs: Context_Menu_Delete_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`समूह से इवेंट सफलतापूर्वक हटा दिए गए`)
};

const pt_pt2_context_menu_delete_success_toast = /** @type {(inputs: Context_Menu_Delete_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eventos excluídos do grupo com sucesso`)
};

/**
* | output |
* | --- |
* | "Events deleted from group successfully" |
*
* @param {Context_Menu_Delete_Success_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const context_menu_delete_success_toast = /** @type {((inputs?: Context_Menu_Delete_Success_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Context_Menu_Delete_Success_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_context_menu_delete_success_toast(inputs)
	if (locale === "de") return de_context_menu_delete_success_toast(inputs)
	if (locale === "it") return it_context_menu_delete_success_toast(inputs)
	if (locale === "ru") return ru_context_menu_delete_success_toast(inputs)
	if (locale === "es") return es_context_menu_delete_success_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_context_menu_delete_success_toast(inputs)
	if (locale === "ja") return ja_context_menu_delete_success_toast(inputs)
	if (locale === "hi") return hi_context_menu_delete_success_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_context_menu_delete_success_toast(inputs)
	return en_context_menu_delete_success_toast(inputs)
});